/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelRoutingGuideUserGroups.ts        *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const AutogenUserSavedSearchEndpoint = "lme/powerbroker/routing-guide-user-groups";

export class AutogenModelRoutingGuideUserGroups<RowType extends ModelRow> extends Endpoint<RowType, RowRoutingGuideUserGroupsFields> {
    constructor(ctor: RowConstructor) {
        super(AutogenUserSavedSearchEndpoint, ctor);
    }
}

export class AutogenRowRoutingGuideUserGroups extends ModelRow<RowRoutingGuideUserGroupsFields> {
    constructor(values?: Partial<RowRoutingGuideUserGroupsFields>) {
        super(AutogenUserSavedSearchEndpoint, true, values);
    }
}

export interface RowRoutingGuideUserGroupsFields {
    company_id: string;
    descr: string;
    id: string;
    routing_guide_id: string;
    user_group: string;
}

